<template>
  <div>
    <template v-for="i1 in Math.ceil((breakdown || []).length / 2)" :key="i1">
      <div>
        <div class="row">
          <div class="col-sm-1" />
          <template v-for="(result, i2) in breakdown">
            <div class="col-sm-5" :key="i2" v-if="Math.floor(i2 / 2) === i1 - 1">
              <Head
                :values="result.rawRatings.ratings"
                valueType="DecimalValue"
                style="width: 50%; margin: 0 auto"
                kind="TeamEffectivenessIndividualDiamond"
              />
              <h5 class="text-center">{{ result.name }}</h5>
              <div style="height: 20px" />
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import {
  TeamEffectivenessRatingsApiModel,
  TeamEffectivenessReviewApiModel,
} from "../../api-models";
import Head from "./gyre-head.vue";
import { getTeamEffectivenessReport } from "../team-effectiveness/get-team-effectiveness-report-team-id";

const props = defineProps<{
  reviewId: string | undefined;
}>();

const teamEffectivenessReport = ref<TeamEffectivenessReviewApiModel | null>(null);

const breakdown = computed<{ name: string; rawRatings: TeamEffectivenessRatingsApiModel }[]>(() => {
  const br =
    teamEffectivenessReport.value?.questionnaires.map((r) => ({
      name: `${r.reviewerDetails.firstName} ${r.reviewerDetails.lastName}`,
      rawRatings: r.rawRatings,
    })) ?? [];

  return br;
});

onMounted(() => {
  getTeamEffectivenessReport(props.reviewId).then((data) => {
    teamEffectivenessReport.value = data;
  });
});
</script>
